import { Card } from 'antd';
import styled from 'styled-components';

export const CardWrapper = styled(Card)`
  box-shadow: inset 40px -40px 40px rgba(255, 255, 255, 0.6);
  background-color: var(--background);
  border: none;
  border-radius: 40px;

  .section-card {
    display: flex;
    justify-content: space-between;

    & > div:nth-child(2) {
      .header-card {
        justify-content: end;
      }
      .label-card {
        text-align: end;
      }
    }
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 40px;
`;

export const IconWrapper = styled.div`
  background: white;
  width: 60px;
  height: 60px;
  border-radius: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LabelsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: fit-content;
`;

export const LabelWrapper = styled.div`
  font-weight: 600;
  min-width: 65px;

  .title {
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;
  }

  .desc {
    font-size: 14px;
    line-height: 16px;
  }
`;
